import { TranslationObject } from '@ngx-translate/core';
import { LanguageCode } from '../types/rest-api';
import { de } from './locales/de';
import { fr } from './locales/fr';
import { it } from './locales/it';

export const FALLBACK_LANGUAGE: LanguageCode = 'de';

export const LANGUAGES: readonly LanguageCode[] = ['de', 'fr', 'it'];

export const TRANSLATIONS: Record<LanguageCode, TranslationObject> = {
  de,
  fr,
  it,
};

export function isLanguageCode(value: unknown): value is LanguageCode {
  return LANGUAGES.includes(value as LanguageCode);
}
